import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import InputLabel from '@material-ui/core/InputLabel';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import FormHelperText from '@material-ui/core/FormHelperText';

import { TRANSLATIONS } from 'translations/index';

import { useStyles } from './styles';

const TextareaInput = ({
  input,
  label,
  isTranslateError,
  language,
  className,
  placeholder,
  isAutosize,
  meta: { touched, error },
  ...otherProps
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classNames(classes.root, className)}>
      <InputLabel className={classes.label} htmlFor={`${label}-input`}>
        {typeof label === 'string' ? t(label) : label}
      </InputLabel>

      <TextareaAutosize
        id={`${label}-input`}
        placeholder={t(placeholder)}
        className={classNames(classes.textarea, {
          [classes.error]: touched && error,
          [classes.autoSizeTextarea]: isAutosize
        })}
        rowsMax={4}
        {...input}
        {...otherProps}
      />

      {touched && error && (
        <FormHelperText error>
          {isTranslateError ? t(TRANSLATIONS[language][error]) : t(error)}
        </FormHelperText>
      )}
    </div>
  );
};

export default TextareaInput;
